import request, { METHODS } from '@/api'
import UrlConfig from '@/api/UrlConfigs.ts'

const { GoodsFrontendTenantWeb, Platform } = UrlConfig

// 添加收藏
export const favoritesAdd = async data => {
  return request(GoodsFrontendTenantWeb.FavoritesAdd, {
    method: METHODS.POST,
    data,
  })
}
// 取消收藏
export const favoritesDelete = async data => {
  return request(GoodsFrontendTenantWeb.FavoritesDelete, {
    method: METHODS.DELETE,
    data,
  })
}
// 查询收藏
export const favoritesList = async data => {
  return request(GoodsFrontendTenantWeb.FavoritesList, {
    method: METHODS.POST,
    data,
  })
}
// 查询详情
export const selectProductSpuDetail = async data => {
  return request(GoodsFrontendTenantWeb.SelectProductSpuDetail, {
    method: METHODS.POST,
    data,
  })
}
// 风格查询
export const getStyleList = async data => {
  return request(Platform.DataDictionaryList, {
    method: METHODS.POST,
    data,
  })
}
// 产地查询
export const getOriginList = async data => {
  return request(GoodsFrontendTenantWeb.OriginList, {
    method: METHODS.POST,
    data,
  })
}
// 规格查询
export const getSpecsList = async data => {
  return request(GoodsFrontendTenantWeb.SpecsList, {
    method: METHODS.POST,
    data,
  })
}
// 商品库分类查询
export const goodsStoreCategoryTree = async data => {
  return request(GoodsFrontendTenantWeb.GoodsStoreCategoryTree, {
    method: METHODS.POST,
    data,
  })
}
// 查询适用套餐
export const queryApplyPackage = async data => {
  return request(GoodsFrontendTenantWeb.QueryApplyPackage, {
    method: METHODS.GET,
    data,
  })
}
// 产品库分页查询
export const goodsStorePage = async data => {
  return request(GoodsFrontendTenantWeb.GoodsStorePage, {
    method: METHODS.POST,
    data,
  })
}
// 品牌查询
export const getBrandList = async data => {
  return request(GoodsFrontendTenantWeb.BrandList, {
    method: METHODS.POST,
    data,
  })
}
// 报价明细查询
export const getListBudgetDtl = async options => {
  return request(GoodsFrontendTenantWeb.ListBudgetDtl, {
    method: METHODS.POST,
    ...options,
  })
}
